import { Header } from 'components/molecules';
import { ListAMBotTemplate } from 'components/templates';
import { withAuth } from 'HOCs';

const breadcrumbs = [{ label: 'Administración' }];

const ListBotPage = () => {
  return (
    <>
      <Header
        title="Bots"
        subtitle="Administra tus bots"
        breadCrumbsProps={{ breadcrumbs: breadcrumbs }}
      />
      <ListAMBotTemplate />
    </>
  );
};

export default withAuth(ListBotPage, undefined, 'mayasoft');
